<template lang='pug'>
  .form_edit
    .form_group
      .form-item.split
        label
          | Form Fields
        .field(v-for='(field, index) in fields')
          el-checkbox.field-checkbox(
            :disabled='is_force_enabled(field.name)'
            v-model='field.show_field'
            @change='change_field($event, "show_field", index)')
          .field-name(@click='change_field(!field.show_field, "show_field", index)')
            | {{ field.display_name | titleize }}
        .field
          el-checkbox.field-checkbox(
            v-model='show_contact_approval'
            @change='change($event, "show_contact_approval")')
          .field-name(@click='change(!show_contact_approval, "show_contact_approval")')
            | Newsletter Signup
      .form-item.split
        label
          | Required
        .toggle(v-for='(field, index) in fields')
          el-switch(
            :disabled='is_force_required(field.name)'
            v-model='field.required'
            @change='change_field($event, "required", index)')
          el-button.delete_button(
            v-if="field.is_deletable"
            @click='delete_field(field.name)'
            type="text")
            .pbxx-icon.pbxx-icon-delete
      .form-item(@keyup.enter="add_field")
        label
          | Add Another Field
        el-input(
          v-model="add_field_input"
          )
          el-button(
            slot="append"
            @click="add_field")
            .pbxx-icon.pbxx-icon-plus.add_button
      .form-item
        label
          | Email {{ brand.retailer_alias | titleize }}s For New Leads
        el-switch.preview_switch(
          v-model='new_leads_send_transactional_email'
          @change='toggle_transactional_email')
      .form-item
        label
          | Label Color
        pbxx_color_picker(
          :color='label_color'
          @input='change($event, "label_color")')
      .form-item
        label
          | Label Font
        el-select(
          v-model='label_font'
          @change='change($event, "label_font")')
          el-option(
            v-for="option in font_options"
            :key="option.value"
            :value="option.value")
              span(:style="{fontFamily: option.value}") {{option.value}}
      .form-item
        label
          | Button Text
        el-input.button_text_input(
          :value='button_text'
          placeholder='Customize button text (optional)'
          @input='change($event, "button_text")')
      .form-item
        label
          | Button Font
        el-select(
          v-model='button_font'
          @change='change($event, "button_font")')
          el-option(
            v-for="option in font_options"
            :key="option.value"
            :value="option.value")
              span(:style="{fontFamily: option.value}") {{option.value}}
      .form-item
        label
          | Button Color
        pbxx_color_picker(
          :color='button_color'
          @input='change($event, "button_color")')
      .form-item
        label
          | Button Text Color
        pbxx_color_picker(
          :color='text_color'
          @input='change($event, "text_color")')
      .form-item
        label
          | Success Message
        el-input(
          v-model="success_message"
          @input='change($event, "success_message")')
      .form-item
        label
          | Preview Success Message
        el-switch.preview_switch(
          v-model='preview_success_message'
          @change='change($event, "preview_success_message")')
</template>

<script>
  import _ from 'lodash'
  import { config_obj } from '../utils/firebase.js'
  import Cookies from 'js-cookie'
  import axios from 'axios'

  export default {
    name: 'form_edit',
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      asset_public_id: {
        type: String,
        required: false,
        default: ""
      },
      campaign: {
        type: Object,
        required: true
      },
      brand: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        add_field_input: '',
        default_fonts: [
          { value: 'Lato', label: 'Lato' },
          { value: 'Lucida Sans Unicode', label: 'Lucida Sans' },
          { value: 'Open Sans', label: 'Open Sans' },
          { value: 'Trebuchet', label: 'Trebuchet' },
          { value: 'Source Sans Pro', label: 'Source Sans Pro' },
          { value: 'Roboto', label: 'Roboto' }
        ],
        force_enabled_fields: ['first_name', 'last_name', 'email_address'],
        force_required_fields: ['first_name', 'last_name', 'email_address'],
        new_leads_send_transactional_email: this.campaign.leads_always_send_transactional_email,
        preview_success_message: false
      }
    },
    computed: {
      font_options() {
        const google_fonts = this.brand.fonts ?
          this.brand.fonts.map(font => {
            return {
              value: font.family,
              label: font.family
            }
          })
          :
          []

        const custom_fonts = this.brand.custom_fonts ?
          this.brand.custom_fonts.map(font => {
            return {
              value: font.family,
              label: font.family
            }
          })
          :
          []
        return [...this.default_fonts, ...google_fonts, ...custom_fonts]
      },
      fields() {
        return this.landing_page_widget.draft_content.inputs
      },
      button_color() {
        return this.landing_page_widget.draft_content.button_color
      },
      label_color() {
        return this.landing_page_widget.draft_content.label_color
      },
      text_color() {
        return this.landing_page_widget.draft_content.text_color
      },
      button_text() {
        return this.landing_page_widget.draft_content.button_text
      },
      button_font() {
        return this.landing_page_widget.draft_content.button_font
      },
      label_font() {
        return this.landing_page_widget.draft_content.label_font
      },
      success_message() {
        return this.landing_page_widget.draft_content.success_message
      },
      show_contact_approval() {
        return this.landing_page_widget.draft_content.show_contact_approval
      }
    },
    destroyed() {
      this.change(false, "preview_success_message")
    },
    filters: {
      titleize(str) {
        if (str) {
          return _.startCase(str)
        }
      }
    },
    methods: {
      async toggle_transactional_email(val) {
        const response = await axios({
          url: `${config_obj.api_base_path}/v2/campaigns/${this.campaign.id}`,
          method: 'PUT',
          data: {
            campaign: {
              leads_always_send_transactional_email: val
            }
          },
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`
          }
        })
      },
      change(val, key) {
        this.landing_page_widget.draft_content[key] = val
        this.$emit('input', this.landing_page_widget)
      },
      change_field(val, key, index) {
        this.landing_page_widget.draft_content.inputs[index][key] = val
        if (key === 'show_field' && !val) {
          this.change_field(false, 'required', index)
        }
        this.$emit('input', this.landing_page_widget)
      },
      is_force_enabled(field) {
        return _.includes(this.force_enabled_fields, field)
      },
      is_force_required(field) {
        return _.includes(this.force_required_fields, field)
      },
      add_field() {
        if (this.add_field_input !== "") {
          const new_field = {
            display_name: _.capitalize(this.add_field_input),
            is_deletable: true,
            name: this.add_field_input.toLowerCase().replace(/ /g, '_'),
            required: false,
            show_field: true
          }
          this.landing_page_widget.draft_content.inputs.push(new_field)
          this.$emit('input', this.landing_page_widget)
          this.add_field_input = ''
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Blank fields cannot be added to forms.'
          })
        }
      },
      delete_field(name) {
        _.remove(this.landing_page_widget.draft_content.inputs, input => {
          return input.name === name
        })
        this.$emit('input', this.landing_page_widget)
        this.$nextTick(() => this.$forceUpdate())
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";

  .form-item {
    margin-bottom: 17px;
    &.split {
      display: inline-block;
      width: 50%;
      vertical-align: top;
    }
  }
  .field {
    padding: 10px 0;
    &-checkbox {
      margin: 0 5px 0 0;
    }
    &-name {
      display: inline-block;
      width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      vertical-align: top;
    }
    &-name.transactional-email {
      width: auto;
    }
  }

  .add_button {
    font-size: 25px;
    padding: 10px 0;
  }

  .delete_button {
    font-size: 16px;
    color: get-color(gray-dark);
    padding: 0 10px;
    margin-left: 10px;
    &:hover {
      color: get-color(gray-darkest);
    }
  }

  .toggle {
    padding: 10px 0;
  }

  .preview_switch {
    margin-left: 5px;
  }

  .upload {
    &-thumbnail,
    &-options {
      display: inline-block;
      vertical-align: top;
    }
    &-thumbnail {
      height: 52px;
      width: 52px;
      margin-right: 15px;
      &-placeholder {
        text-align: center;
        color: get-color(gray);
        background: get-color(gray-lightest);
        height: 100%;
        font-size: 36px;
      }
    }
    &-copy {
      font-size: 12px;
      margin-bottom: 4px;
      width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

</style>
